import type { LocationQuery } from '#vue-router'

export type UseProductFinderType = 'watches' | 'straps'

/**
 * Extracts facets from query parameters.
 *
 * Input:
 * {
 *   'f:facet_id': 'term_1',
 *   'f:facet_id2': 'term_2___term_3',
 *   'f:facet_id3': ['term_7___term_8', 'term_9'],
 * }
 *
 * Output:
 * {
 *    'facet_id': ['term_1'],
 *    'facet_id2': ['term_2, 'term_3'],
 *    'facet_id3': ['term_7, 'term_8', 'term_9'],
 * }
 */
export function extractFacetsFromQuery(
  query: LocationQuery | Record<string, string | string[] | null | undefined>,
): Record<string, string[]> {
  return Object.entries(query).reduce<Record<string, string[]>>(
    (acc, [key, facets]) => {
      // Query keys for facets are in the form of f:FACET___FILTER.
      if (!key.startsWith('f:')) {
        return acc
      }

      const facetId = key.substring(2)
      const filters = (
        typeof facets === 'string' ? facets : (facets || []).join('___')
      ).split('___')

      if (!filters.length) {
        return acc
      }

      if (!acc[facetId]) {
        acc[facetId] = []
      }

      acc[facetId].push(...filters)
      return acc
    },
    {},
  )
}
